import React from "react";
import { Download } from "../../Pages/DownloadPage/Download";

function DownloadsPage() {
  return <div>
    <Download/>
  </div>;
}

export { DownloadsPage };
